import React, { useState } from 'react';
import { StyledPaper, StyledTable, StyledTableRow, StyledTableCell } from '../../../uiComponents/MuiTable/StyledTable.js';
import MuiTableHeader from '../../../uiComponents/MuiTable/MuiTableHeader.js';
import { stableSort, getComparator, handleRequestSort } from '../../../uiComponents/MuiTable/MuiHelper.js';
import { TableBody, TableContainer, TextField, MenuItem, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import muiInputStyles from '../../../uiComponents/MuiInput/MuiInputStyles.js';

import { instrumentOptions, reagentKitOptions } from '../../../config/BiochemicalInstrumentation.js';
import aboutWhatDataED3NCollects from '../../../config/AboutWhatDataED3NCollects.js';
const headCells = [
  { label: 'Analyte Group', id: 'AnalyteGroup', numeric: false, disablePadding: false },
  { label: 'Instrument', id: 'Instrument', numeric: false, disablePadding: false, type: 'noSort' },
  { label: 'Reagent Kit', id: 'ReagentKit', numeric: false, disablePadding: false, type: 'noSort' },
  { label: 'Lot Number', id: 'LotNumber', numeric: false, disablePadding: false, type: 'noSort' },
];

export default function ConfirmBiochemicalWorkflowTable(props) {
  const classes = muiInputStyles();
  const { data, analyteGroups, selectedValues, handleTableSelectionChange } = props;
  const [order, setOrder] = useState('asc'); //default sort direction
  const [orderBy, setOrderBy] = useState('AnalyteGroup'); //default sort column for table
  const [isDataInfoOpen, setIsDataInfoOpen] = useState(false);

  const handleChange = (analyteGroup, field, value) => {
    handleTableSelectionChange(analyteGroup, { [field]: value });
  };

  return (

    <>
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<InfoOutlined fontSize='small' />}
        onClick={() => setIsDataInfoOpen(true)}
      >
        {aboutWhatDataED3NCollects.title}
      </Button>
    </div>
    <Dialog
      open={isDataInfoOpen}
      onClose={() => setIsDataInfoOpen(false)}
      aria-labelledby="about-what-data-ed3n-collects-title"
      maxWidth="sm"
    >
      <DialogTitle id="about-what-data-ed3n-collects-title">{aboutWhatDataED3NCollects.title}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" style={{ fontSize: '1rem' }}>
          {aboutWhatDataED3NCollects.content}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setIsDataInfoOpen(false)}>Close</Button>
      </DialogActions>
    </Dialog>
    <StyledPaper>
      <TableContainer>
        <StyledTable size="small" aria-label="Biochemical Instrumentation Settings">
          <MuiTableHeader 
            headCells={headCells}
            order={order}
            orderBy={orderBy}
            onRequestSort={(event, property) => handleRequestSort(event, property, order, orderBy, setOrder, setOrderBy)}
          />
          <TableBody>
            {data && data.length ? (
              stableSort(data, getComparator(order, orderBy))
              .map((row, index) => {
                const rowValues = selectedValues?.[row.AnalyteGroup] || {};
                return (
                  <StyledTableRow key={row.AnalyteGroup || index}>
                    <StyledTableCell style={{ width: '25%' }}>
                      {analyteGroups[row.AnalyteGroup] || row.AnalyteGroup}
                    </StyledTableCell>
                    <StyledTableCell style={{ width: '25%' }}>
                      <TextField
                        select
                        fullWidth
                        size="small"
                        className={classes.muiInputs}
                        label="Instrument"
                        value={rowValues.Instrument || row.Instrument || ''}
                        onChange={e => handleChange(row.AnalyteGroup, 'Instrument', e.target.value)}
                        variant="outlined"
                        SelectProps={{ 
                          MenuProps: { 
                            disableScrollLock: true, 
                            disablePortal: true, // makes the popover render inside the normal React tree (instead of attaching it to the body)
                          }, 
                        }}
                      >
                        {instrumentOptions.map(opt => (
                          <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                        ))}
                      </TextField>
                    </StyledTableCell>
                    <StyledTableCell style={{ width: '25%' }}>
                      <TextField
                        select
                        fullWidth
                        size="small"
                        className={classes.muiInputs}
                        label="Reagent Kit"
                        value={rowValues.ReagentKit || row.ReagentKit || ''}
                        onChange={e => handleChange(row.AnalyteGroup, 'ReagentKit', e.target.value)}
                        variant="outlined"
                        SelectProps={{ // prevent content shift
                          MenuProps: {
                            disableScrollLock: true, 
                            disablePortal: true, // makes the popover render inside the normal React tree (instead of attaching it to the body) 
                          }
                        }}
                      >
                        {reagentKitOptions.map(opt => (
                          <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                        ))}
                      </TextField>
                    </StyledTableCell>
                    <StyledTableCell style={{ width: '25%' }}>
                      <TextField
                        fullWidth
                        size="small"
                        className={classes.muiInputs}
                        label="Lot Number"
                        value={rowValues.LotNumber || row.LotNumber || ''}
                        onChange={e => handleChange(row.AnalyteGroup, 'LotNumber', e.target.value)}
                        variant="outlined"
                        inputProps={{ maxLength: 25 }}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={4} style={{ textAlign: 'center' }}>
                  No biochemical instrumentation settings found
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </StyledPaper>
        </>
  );
}